export const initialFilterOptions = {
  petsAllowed: false,
  adaAccomodations: false,
  mealsProvided: false,
  hotelNames: [],
  isFilter: false,
  searchTerm: '',
  changingRadiusFilterOverlay: false,
};
